import styled from "styled-components";
import { theme } from "../../../../../../constants/StyledComponents";

export const StyledBodyDevelopmentComments = styled.div<{ $edit: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $edit }) => ($edit ? "0" : "20px")};

  & .career-advancement-panel-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: ${({ $edit }) => ($edit ? "0" : "20px")};

    & .career-advancement-panel {
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      border: 1px solid ${theme.colors.purple_2};
    }
  }

  & .career-development-committee-note-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const StyledBusinessAreaManagerSection = styled.div<{
  $bordered: boolean;
  $edit: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: ${({ $bordered }) => $bordered && "20px"};
  padding-bottom: none;
  margin-bottom: ${({ $edit, $bordered }) =>
    $edit && $bordered ? "20px" : "0"};
  border-top: ${({ $bordered }) =>
    $bordered ? `1px solid ${theme.colors.purple_2}` : "none"};
  border-bottom: ${({ $bordered }) =>
    $bordered ? `1px solid ${theme.colors.purple_2}` : "none"};
`;

export const StyledCareerAdvancementRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-bottom: 1px solid ${theme.colors.purple_2};

  &:last-child {
    border-bottom: none;
  }

  & .salary-evaluation-form {
    display: flex;
    flex-direction: row;
    gap: 30px;

    & .salary-evaluation-option {
      display: flex;
      gap: 10px;
    }
  }
`;
